// extracted by mini-css-extract-plugin
export default {"CardBaseWithSash":"index-module__CardBaseWithSash--P7xBn","dragDisabled":"index-module__dragDisabled--yztZ1","isRedacted":"index-module__isRedacted--KqQgR"};